import createClient from 'openapi-fetch';
import { createImmutableHook, createInfiniteHook, createMutateHook, createQueryHook } from 'swr-openapi';
import { isMatch } from 'lodash';
import type { paths } from '../types/schema'; // generated by openapi-typescript

export const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_HOST_API,
  headers: {
    get Authorization() {
      return `Bearer ${localStorage.getItem('accessToken')}`;
    },
  },
});

const prefix = "partners-api";

export const useQuery = createQueryHook(client, prefix);
export const useImmutable = createImmutableHook(client, prefix);
export const useInfinite = createInfiniteHook(client, prefix);
export const useMutate = createMutateHook(
  client,
  prefix,
  isMatch, // Or any comparision function
);

export function joinErrors(err: { errors: { detail: string }[] }) {
  try {
    const anyErr: any = err as any;
    if (!anyErr) return 'Unknown error';
    if (Array.isArray(anyErr.errors)) {
      return anyErr.errors
        .map((e: any) => e?.detail ?? (typeof e === 'string' ? e : JSON.stringify(e)))
        .join('\n');
    }
    if (typeof anyErr === 'string') return anyErr;
    if (anyErr.detail) return anyErr.detail;
    if (typeof anyErr === 'object') {
      const values = Object.values(anyErr).flatMap((v: any) => (Array.isArray(v) ? v : [v]));
      return values
        .map((v: any) => (typeof v === 'string' ? v : v?.detail ?? JSON.stringify(v)))
        .join('\n');
    }
    return 'Unknown error';
  } catch (e) {
    return 'Unknown error';
  }
}
